/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { useState } from 'react';
import '../_chunks/dep-2acfafca.js';

function useHover(props) {
  var readonly = props.readonly,
    disabled = props.disabled,
    onMouseenter = props.onMouseenter,
    onMouseleave = props.onMouseleave;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHover = _useState2[0],
    setIsHover = _useState2[1];
  var addHover = function addHover(context) {
    if (readonly || disabled) return;
    setIsHover(true);
    onMouseenter === null || onMouseenter === void 0 ? void 0 : onMouseenter(context);
  };
  var cancelHover = function cancelHover(context) {
    if (readonly || disabled) return;
    setIsHover(false);
    onMouseleave === null || onMouseleave === void 0 ? void 0 : onMouseleave(context);
  };
  return {
    isHover: isHover,
    addHover: addHover,
    cancelHover: cancelHover
  };
}

export { useHover as default };
//# sourceMappingURL=useHover.js.map
